module.exports = __webpack_public_path__ + "img/like.6da50df8.svg";